import React from 'react'

interface ContainerProps extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    children: React.ReactNode
}

const Container: React.FC<ContainerProps> = ({ children, className = '', ...rest }) => {
    return (
        <div className={`container max-w-[1250px] mx-auto ${className}`} {...rest}>
            {children}
        </div>
    )
}

export default Container
